import { IColuna } from "app/types/IColuna";
import React from "react";
import { ThProps } from "./Th";

export const ObterTh = (colunas: IColuna[]) => ({nomeColuna}:{nomeColuna:string}) => {
    return null
}